import { Segment } from '@hotjar/global-filters/src/domains/global-filters/model/segment';

const shouldGetSegment = (segment: Segment): boolean => {
  if (!segment || !segment.unsupported_features) {
    return false;
  }

  // In order to handle upsell correctly for error filter, we have to put it on the scale plan on the backend side
  // Problem: we still have to support the scale trial for now.
  // Workaround: if the only unsupported_features is the error filters, we'll still allow to change the segment

  return (
    segment.unsupported_features.length === 0 ||
    (segment.unsupported_features.length === 1 &&
      segment.unsupported_features.includes('filters.error'))
  );
};

/**
 * Gets segment by id.
 */
export const getSegmentById = (id: number, segments: Segment[]): Segment | undefined => {
  return segments.find((segment) => segment.id === id && shouldGetSegment(segment));
};
